import React, { useEffect } from 'react';
import { Box, Heading, Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../routes/routes';

const Home: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(ROUTES.PROJECTS);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box textAlign="center" py={10} px={6}>
      <Heading as="h1" size="2xl" mb={4}>
        Welcome to Xegai Projects
      </Heading>

      <Button colorScheme="teal" size="lg" onClick={() => navigate(ROUTES.PROJECTS)}>
        View Projects
      </Button>
    </Box>
  );
};

export default Home;
